import Swiper from 'swiper/bundle';
// import Swiper and modules styles


// init Swiper:
document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('.ouw-logo-bar-carousel.swiper') === null) {
		return;
	}
	document.querySelectorAll('.ouw-logo-bar-carousel.swiper').forEach((element) => {
		let slides = element.dataset?.slides || 2;
		const swiper = new Swiper(element, {
			slidesPerView: slides,
			slidesPerGroup: 1,
			loop: false,
			spaceBetween: Number(slides) > 2 ? 30 : 15,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true,
				pageUpDown: true
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			breakpoints: {
				0: {
					slidesPerView: 2,
					slidesPerGroup: 1,
				},
				782: {
					slidesPerView: slides,
					slidesPerGroup: 1,
				}
			}
		});
	})
})
